/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface GetOtsSearch$Params {
  /**
   * Id interne utilisateur referencant l'intervenant sur l'OT
   */
  idIntervenant?: string;

  /**
   * Id interne site
   */
  idSite?: string;

  /**
   * Statut des OT a prendre en compte (affecte, clos, a faire mais non affecte ... )
   */
  statut?: string;

  /**
   * Type d'OT a recuperer (correctif, preventif)
   */
  typeActivite?: string;

  /**
   * Activites avec date fin previsionnelle apres date en parametre
   */
  previsionDebutApresDate?: string;

  /**
   * Activites avec date fin previsionnelle avant date en parametre
   */
  previsionFinApresDate?: string;

  /**
   * Activites avec date fin previsionnelle avant date en parametre
   */
  previsionDebutAvantDate?: string;

  /**
   * Activites avec date fin previsionnelle apres date en parametre
   */
  previsionFinAvantDate?: string;

  /**
   * Si ce paramètre est communiqué peu importe sa valeur alors ne renvoyer que les 20 derniers OTs
   */
  historique?: boolean;

  /**
   * Limite
   */
  limite?: number;

  /**
   * Si ce paramètre est communiqué à true, alors il s'agit d'un get tournée par equipe
   */
  team?: string;

  /**
   * Activites avec date planification avant date en parametre
   */
  planificationAvantDate?: string;

  /**
   * Activites avec date planification apres date en parametre
   */
  planificationApresDate?: string;
}

export function getOtsSearch(
  http: HttpClient,
  rootUrl: string,
  params?: GetOtsSearch$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getOtsSearch.PATH, 'get');
  if (params) {
    rb.query('idIntervenant', params.idIntervenant, {});
    rb.query('idSite', params.idSite, {});
    rb.query('statut', params.statut, {});
    rb.query('typeActivite', params.typeActivite, {});
    rb.query('previsionDebutApresDate', params.previsionDebutApresDate, {});
    rb.query('previsionFinApresDate', params.previsionFinApresDate, {});
    rb.query('previsionDebutAvantDate', params.previsionDebutAvantDate, {});
    rb.query('previsionFinAvantDate', params.previsionFinAvantDate, {});
    rb.query('historique', params.historique, {});
    rb.query('limite', params.limite, {});
    rb.query('team', params.team, {});
    rb.query('planificationAvantDate', params.planificationAvantDate, {});
    rb.query('planificationApresDate', params.planificationApresDate, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

getOtsSearch.PATH = '/v2/ots/search';
